/** 导航栏列表 */
export const navList = [
  { key: 'home', label: '首页' },
  { key: 'publicBeta', label: '公测活动' },
  { key: 'characteristics', label: '游戏特色' },
  { key: 'introduced', label: '门派介绍' },
  { key: 'attention', label: '关注我们' }
];
